const settingManagement = {
  state: () => ({
    /** 異常原因管理列表 */
    abnormalReasonList: [],

    /** 缺陷管理列表 */
    defectList: [],

    /** 檢驗判定管理列表 */
    inspecJudgeList: [],

    /** 異常原因管理新增對話框是否顯示 */
    abnormalReasonAddFormVisible: false,

    /** 異常原因管理Tab名稱 */
    activeName: '',

    /** 缺陷管理新增對話框是否顯示 */
    defectDefineFormVisible: false,

    /** 檢驗判定管理 對話框是否顯示 */
    inspecJudgDefineFormVisible: false,

    /** 層別設定-產品列表 */
    productList: [],

    /** 層別設定-機台列表 */
    machineList: [],

    /** 層別設定-製程列表 */
    processList: [],

    /** 層別設定-參數列表 */
    paramsList: [],

    /** 層別設定-產品 新增對話框是否顯示 */
    levelProductFormVisible: false,

    /** 層別設定 Tab數值 */
    levelActiveTabValue: 0,

    /** 層別設定-機台 新增對話框是否顯示 */
    levelMachineFormVisible: false,

    /** 層別設定-製程 新增對話框是否顯示 */
    levelGroupFormVisible: false,

    /** 層別設定-參數 新增對話框是否顯示 */
    levelParamsFormVisible: false,

    /** 動態欄位設定 編輯對話框是否顯示 */
    dynamicFieldSettingsEditVisible: false,

    /** 管制圖規則列表  */
    controlChartRulesList: [],

    /** 管制圖規則 新增對話框是否顯示 */
    controlChartRulesCreateVisible: false,

    /** 標準樣本設定列表 */
    standardSampleSettingList: [],

    /** 標準樣本設定 新增對話框是否顯示 */
    goldenSampleSettingCreateVisible: false,

    /** 制程能力等級列表 */
    processAnalysisRanksList: [],

    /** 制程能力等級 新增對話框是否顯示 */
    processAnalysisRanksCreateVisible: false,

    /** 製程能力規則列表 */
    processAnalysisRuleList: [],

    /** 製程能力規則 新增對話框是否顯示 */
    processAnalysisRuleCreateVisible: false,

    /** 排程設定列表 */
    scheduleSettingsList: [],

    /** 排程設定 新增與編輯對話框是否顯示 */
    scheduleSettingsFormVisible: false,
  }),

  mutations: {
    /** 異常原因管理列表 設值 */
    setAbnormalReasonList(state, value) {
      state.abnormalReasonList = value;
    },

    /** 缺陷管理列表 設值 */
    setDefectList(state, value) {
      state.defectList = value;
    },

    /** 檢驗判定管理列表 */
    setInspecJudgeList(state, value) {
      state.inspecJudgeList = value;
    },

    /** 異常原因管理新增對話框是否顯示 設值  */
    setAbnormalReasonAddFormVisible(state, value) {
      state.abnormalReasonAddFormVisible = value;
    },

    /** 異常原因管理Tab名稱 設值 */
    setAbnormalReasonActiveName(state, value) {
      state.activeName = value;
    },

    /** 缺陷管理新增對話框是否顯示 設值 */
    setDefectDefineFormVisible(state, value) {
      state.defectDefineFormVisible = value;
    },

    /** 檢驗判定管理 對話框是否顯示 設值 */
    setInspecJudgDefineFormVisible(state, value) {
      state.inspecJudgDefineFormVisible = value;
    },

    /** 層別設定-產品列表 設值 */
    setProductList(state, value) {
      state.productList = value;
    },

    /** 層別設定-機台列表 設值 */
    setMachineList(state, value) {
      state.machineList = value;
    },

    /** 層別設定-製程列表 設值 */
    setProcessList(state, value) {
      state.processList = value;
    },

    /** 層別設定-參數列表 設值 */
    setParamsList(state, value) {
      state.paramsList = value;
    },

    /** 層別設定 新增對話框是否顯示 設值 */
    setLevelProductFormVisible(state, value) {
      state.levelProductFormVisible = value;
    },

    /** 層別設定 Tab數值 設值 */
    setLevelActiveTabValue(state, value) {
      state.levelActiveTabValue = value;
    },

    /** 層別設定-機台 新增對話框是否顯示 設值 */
    setLevelMachineFormVisible(state, value) {
      state.levelMachineFormVisible = value;
    },

    /** 層別設定-製程 新增對話框是否顯示 設值 */
    setLevelGroupFormVisible(state, value) {
      state.levelGroupFormVisible = value;
    },

    /** 層別設定-參數 新增對話框是否顯示 設值 */
    setLevelParamsFormVisible(state, value) {
      state.levelParamsFormVisible = value;
    },

    /** 動態欄位設定 編輯對話框是否顯示 設值 */
    setDynamicFieldSettingsEditVisible(state, value) {
      state.dynamicFieldSettingsEditVisible = value;
    },

    /** 管制圖規則列表 設值 */
    setControlChartRulesList(state, value) {
      state.controlChartRulesList = value;
    },

    /** 管制圖規則 新增對話框是否顯示 設值 */
    setControlChartRulesCreateVisible(state, value) {
      state.controlChartRulesCreateVisible = value;
    },

    /** 標準樣本設定列表 設值 */
    setStandardSampleSettingList(state, value) {
      state.standardSampleSettingList = value;
    },

    /** 標準樣本設定 新增對話框是否顯示 設值 */
    setGoldenSampleSettingCreateVisible(state, value) {
      state.goldenSampleSettingCreateVisible = value;
    },

    /** 制程能力等級列表 設值 */
    setProcessAnalysisRanksList(state, value) {
      state.processAnalysisRanksList = value;
    },

    /** 制程能力等級 新增對話框是否顯示 設值 */
    setProcessAnalysisRanksCreateVisible(state, value) {
      state.processAnalysisRanksCreateVisible = value;
    },

    /** 製程能力規則列表 設值 */
    setProcessAnalysisRuleList(state, value) {
      state.processAnalysisRuleList = value;
    },

    /** 製程能力規則 新增對話框是否顯示 設值 */
    setProcessAnalysisRuleCreateVisible(state, value) {
      state.processAnalysisRuleCreateVisible = value;
    },

    /** 排程設定列表 設值 */
    setScheduleSettingsList(state, value) {
      state.scheduleSettingsList = value;
    },

    /** 排程設定 新增與編輯對話框是否顯示 設值 */
    setScheduleSettingsFormVisible(state, value) {
      state.scheduleSettingsFormVisible = value;
    },
  },
};

export default settingManagement;
